import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import Storage from '@aws-amplify/storage';
import * as Sentry from '@sentry/react';

let config = {};

export const importStack = async () => {
  // eslint-disable-next-line no-undef
  if (ACCOUNT === 'dev') {
    config = await import('../stack.dev-account.json');
  } else if (ENV === 'production') {
    config = await import('../stack.production.json');
  } else {
    config = await import('../stack.staging.json');
  }

  const {
    userPoolWebClientId,
    userPoolId,
    identityPoolId,
    serviceEndpoint,
    CacheBucketName,
  } = config.default;

  const REGION = 'us-east-2';

  Auth.configure({
    mandatorySignIn: true,
    region: REGION,
    userPoolId,
    identityPoolId,
    userPoolWebClientId,
  });

  API.configure({
    endpoints: [
      {
        name: 'api',
        region: REGION,
        // eslint-disable-next-line no-undef
        endpoint:
          ENV === 'development' && LOCAL
            ? 'http://localhost:5000'
            : serviceEndpoint,
      },
    ],
  });

  Storage.configure({
    AWSS3: {
      bucket: CacheBucketName,
      region: REGION,
    },
  });

  if (ENV === 'production') {
    Sentry.init({
      dsn:
        'https://aa4e248f8ba3497095623be3a16b5f7c@o427769.ingest.sentry.io/5372293',
      ignoreErrors: ['ResizeObserver loop limit exceeded']
    });
    window.imgRoute = 'img';
  } else if (ENV === 'staging') {
    Sentry.init({
      dsn:
        'https://e0fe978cd5454891abbfdf5468767710@o427769.ingest.sentry.io/5377043',
      ignoreErrors: ['ResizeObserver loop limit exceeded']
    });
    window.imgRoute = 'img';
  }

  if (ENV === 'development') {
    window.serverConfig = {
      baseUrl: LOCAL ? 'http://localhost:5000' : serviceEndpoint,
      namespace: API_NAMESPACE,
      version: '1.1.1',
      basename: '/',
    };
  } else {
    window.serverConfig = {
      baseUrl: serviceEndpoint,
      namespace: API_NAMESPACE,
      version: '1.1.1',
      basename: `/${DELIVERY}`,
    };
  }
}
